<div class="main-content">
    <div class="main-heading">
        <span>
            <span translate>ALL_CONTRACTS</span>
        </span>
        <span class="page-actions text-right" *ngIf="isDisplayOwnContract">
            <a [routerLink]="['./../new']" class="btn btn-success">
                <i class="pi pi-plus"></i>
                <span>
                    <span translate>NEW</span>
                </span>
            </a>
        </span>
    </div>
    <div class="panel-tabs">
        <nav>
            <ul class="nav nav-pills">
                <li [routerLinkActive]="['active']" *ngIf="isDisplayOwnContract">
                    <a [routerLink]="['./all']" translate>ALL</a>
                </li>
                <li [routerLinkActive]="['active']" *ngIf="isHideDisplayOwnContract">
                    <a [routerLink]="['./own']" translate>FOR_YOU</a>
                </li>
            </ul>
        </nav>
    </div>
    <div class="card">
        <div class="card-body">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>